import { useState } from 'react';
import { basePort, getUsernameJwt, headers, isExpiredJwt, parseJwt, setCookie, getRoleJwt } from "../module_auth/AuthService"
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "./common/Toast"
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from 'jwt-decode';

export function MbrPvReg() {
    const navigate = useNavigate();
    const [pvName, setPvName] = useState("");
    const [fullname, setFullname] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [allowRegister, setAllowRegister] = useState(false);
    
     //toast
     const [showToast, setShowToast] = useState(false);
     const [msgToast, setMsgToast] = useState("");

    //mbr role
    function handlePvName(event) {
        setPvName(event.target.value);
    }

    function handleFullname(event) {
        setFullname(event.target.value);
    }

    function handleEmail(event) {
        setEmail(event.target.value);
        setAllowRegister(false)
    }

    function handlePassword(event) {
        setPassword(event.target.value);
    }

    function handlePasswordRepeat(event) {
        setPasswordRepeat(event.target.value);
    }

    function moveTo() {
        // let encodedEmail = window.btoa(email)
        // let encodedFullname = window.btoa(fullname)
        // let url = "/mbr_pv_reg_validation?id=" + encodedEmail + "&fullname=" + encodedFullname;
        let url = "/mbr_pv_reg_validation?id=" + email;
        navigate(url);
    }

    function validateMbr(){
        moveTo()
    }

    function clickSubmit(event) {
        event.preventDefault();
        fetch(basePort + '/authenticate/registration', 
            {method:'post', headers,
                      body:JSON.stringify({
                        email:email,
                        fullname:fullname,
                        plainPassword:password,
                        plainPasswordRepeat:passwordRepeat,
                        role:"TEMP_PV"
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            //login()
                            validateMbr()
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))
    }

    function login() {
        let url = "/login";
        navigate(url);
    }

    function registerBy3rdParty(credentialResponse) {
        const decoded = jwtDecode(credentialResponse.credential);
        fetch(basePort + '/authenticate/registration/3rd', 
            {method:'post', headers,
                      body:JSON.stringify({
                        email:decoded.email,
                        fullname:decoded.name,
                        role:"PV"
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            setTimeout(function() {
                                login()
                            }.bind(this), 3000);
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
            }).catch(error => console.log(error))
    }

    function doubleCheck(event) {
        event.preventDefault();
        //확장 이메일, 비밀번호 검수
        //url - validateEmailPassword        
        fetch(basePort + '/checkEmail', 
            {method:'post', headers,
                      body:JSON.stringify({
                        email:email,
                        fullname:fullname,
                        plainPassword:password,
                        plainPasswordRepeat:passwordRepeat,
                        role:"PV"
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){
                            fadeOutToast(response.validationMessage)
                            setAllowRegister(true)
                        } else {
                            fadeOutToast(response.validationMessage)
                            setAllowRegister(false)
                        }
            }).catch(error => console.log(error))
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 2000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <div class="row mb-5">
                        <div class="col-md-8 col-xl-6 text-center mx-auto">
                            <h2 style={{fontFamily: 'Nanum Gothic'}}>개인회원</h2>
                            <p></p>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-6 col-xl-4" style={{width:'600px'}}>
                            <div class="card mb-5">
                                <div class="card-body d-flex flex-column align-items-center">
                                    <form class="text-center" method="post" style={{width:'300px'}}>
                                        <div class="mb-3"><input class="form-control" type="text" placeholder="이름(실명)" onChange={handleFullname}/></div>
                                        <div class="mb-3"><input class="form-control" type="email" name="email" placeholder="이메일(아이디)" onChange={handleEmail}/></div>
                                        <div class="mb-3"><input class="form-control" type="password" name="password" placeholder="비밀번호(8~16자의 영문, 숫자, 특수기호)" onChange={handlePassword}/></div>
                                        <div class="mb-3"><input class="form-control" type="password" name="password" placeholder="비밀번호 확인" onChange={handlePasswordRepeat}/></div>
                                        <div class="mb-3"><button class="btn btn-secondary d-block w-100" type="submit" onClick={doubleCheck}>중복확인</button></div>
                                        <div class="mb-3"><button class="btn btn-primary d-block w-100" type="submit" onClick={clickSubmit} disabled={!allowRegister}>가입하기</button></div>
                                    </form>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <GoogleLogin
                                    onSuccess={credentialResponse => {
                                        console.log(credentialResponse);
                                        //jwt reader
                                        registerBy3rdParty(credentialResponse)
                                    }}
                                    onError={() => {
                                        fadeOutToast('Login Failed');
                                    }}
                                    text='signup_with'
                                    locale='ko'
                                />
                            </div>
                        </div>
                    </div>
                    <ToastMessage show={showToast} msg={msgToast} />
                    </div>
                </section>
            </main>
        </div>
    );
}